export const getBalanceSubscribtionRequest = (tid) => ({
	source: "terminals",
	what: { terminals: [] },
	where: { tid },
});
